import type { FieldError } from "react-hook-form";
import styles from "./styles.module.css";
import { forwardRef } from "react";

interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  error?: FieldError;
}

const Input = forwardRef(({ error, ...props }: InputProps, ref: React.Ref<HTMLInputElement>) => {
  return (
    <>
      <input ref={ref} className={[styles.inputForm, error && styles.error].filter(Boolean).join(" ")} {...props} />
      {error && <span className={styles.errorText}>{error.message}</span>}
    </>
  );
});

export default Input;
